import { makeStyles } from "@material-ui/core/styles";

const getMakeStyleClasses = (getPropClasses = () => {}) => {
  return makeStyles((theme) => ({
    primaryThemeColor: {
      color: theme.palette.primary.main,
    },
    secondaryThemeColor: {
      color: theme.palette.secondary.main,
    },
    primaryThemeColorBg: {
      backgroundColor: theme.palette.primary.main,
    },
    secondaryThemeColorBg: {
      backgroundColor: theme.palette.secondary.main,
    },
    secondaryTextColor: {
      color: theme.palette.text.secondary,
    },
    ...getPropClasses(theme),
  }))();
};

export { getMakeStyleClasses };
